export default "/_next/static/images/img1-fbaafa832832ae1e467d103589b6ecc0.png";